import { generatePath } from "@routes/generatePath.ts";

const guestJoinPath = "/guest-join/:token";

export const path = {
  join: {
    route: guestJoinPath,
    link: (token: string) => generatePath(guestJoinPath, { token }),
  },
};
